import { render, staticRenderFns } from "./NsButton.vue?vue&type=template&id=1895da32&scoped=true&"
import script from "./NsButton.vue?vue&type=script&lang=js&"
export * from "./NsButton.vue?vue&type=script&lang=js&"
import style0 from "./NsButton.vue?vue&type=style&index=0&id=1895da32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895da32",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsLoading: require('/usr/app/src/components/ns/NsLoading.vue').default,NsIcon: require('/usr/app/src/components/ns/NsIcon.vue').default})
